package br.com.texeratx.boardgametimeapp.core.utils

actual fun getPlatform(): Platform =
    object : Platform {
        override val name: String = "Web"
    }
